export default __webpack_public_path__ + "static/media/me-active.b2506452.svg";